export default abstract class BaseUpdateAccountSettings {
    updatedAt: Date;

    public constructor(updatedAt: Date) {
        this.updatedAt = updatedAt;
    }
}